import * as dates from '@simplybenefits/sb-dates';
import React, { PureComponent } from 'react';
import Text from '../../../components/Text.js';
import Modal from '../../../components/Modals/Modal.js';
import TextInput from '../../../components/TextFields/TextInput.js';
import InputAdornment from "@mui/material/InputAdornment";
import { Visibility as VisibilityIcon, VisibilityOff as VisibilityOffIcon } from '@mui/icons-material';
import DateInput from '../../../components/TextFields/DateInput.js';
import Checkbox from '../../../components/Checkbox.js';
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import * as Services from '../../../services/index.js';
import colors from '../../../theme/colors.js';
import i18n from '../../../localization/i18n.js';
import tokens from '../../../localization/tokens.js';
class TerminationModal extends PureComponent {
  state = {
    anchorEl: null,
    terminationType: null,
    showTerminationModal: false,
    password: '',
    visibility: false,
    signage: {
      name: '',
      signature: '',
      acceptedTerms: false,
      timestampOfAcceptance: null,
      datedOn: null
    }
  };
  _handleSignageChange = (type, value) => {
    if (type === 'acceptedTerms' && value === true) {
      this.setState({
        signage: {
          ...this.state.signage,
          acceptedTerms: true,
          timestampOfAcceptance: dates.getUTC()
        }
      });
      return null;
    }
    this.setState({
      signage: {
        ...this.state.signage,
        [type]: value
      }
    });
    return null;
  };
  _handleInputChange = (type, event) => {
    this.setState({
      [type]: event.target.value.toString()
    });
  };
  _toggleVisibility = () => {
    this.setState({
      visibility: !this.state.visibility
    });
  };
  _validateSignageBlock = async () => {
    const {
      signage,
      password
    } = this.state;
    const passwordError = this.props.isMasterSite ? false : await Services.validateInput('checkEmpty', password);
    let signageNameError = await Services.validateInput('checkEmpty', signage.name);
    const signageSignatureError = await Services.validateInput('checkEmpty', signage.signature);
    const signageDatedOnError = await Services.validateInput('date', signage.datedOn, i18n.locale);
    const signageAcceptedError = !signage.acceptedTerms;
    if (signageAcceptedError) {
      alert(i18n.t(tokens.labels.signage.pleaseAcceptAndAcknowledgeChanges));
      return null;
    }
    if (signage.name !== signage.signature) {
      signageNameError = i18n.t(tokens.labels.signage.signageNameError);
    }
    this.setState({
      signageNameError,
      signageSignatureError,
      signageDatedOnError,
      passwordError
    });
    if (signageNameError || signageSignatureError || signageDatedOnError || passwordError) {
      return false;
    }
    return true;
  };
  render() {
    let productNameToTerminate = null;
    if (this.props.productToTerminate.childProductType && this.props.productToTerminate.childProductType.toLowerCase() !== 'primary') {
      productNameToTerminate = this.props.productToTerminate.name[this.props.productToTerminate.childProductType.toLowerCase()][this.props.member.language];
    } else {
      productNameToTerminate = this.props.productToTerminate.name.primary[this.props.member.language];
    }
    productNameToTerminate = `${this.props.productToTerminate.type.toUpperCase() === 'VOLUNTARY' ? i18n.t(tokens.labels.marketplace.voluntary) : i18n.t(tokens.labels.marketplace.optional)} ${productNameToTerminate}`;
    if ((this.props.productToTerminate.type.toUpperCase() === 'OPTIONAL' || this.props.productToTerminate.isGrandfathered === 1) && !this.props.isMasterSite) {
      return /*#__PURE__*/React.createElement(Modal, {
        small: true,
        open: true,
        onClose: this.props.close,
        title: i18n.t(tokens.titles.productTerminationBlockedTitle),
        primaryButton: {
          label: "close",
          onClick: this.props.close
        },
        loader: this.props.loader
      }, /*#__PURE__*/React.createElement(Text, {
        align: "left",
        medium: true,
        display: "inline-block"
      }, i18n.t(tokens.labels.marketplace.terminationBlocked)));
    }
    if (this.props.productToTerminate.coveragePeriodType.toUpperCase() === 'YEAR') {
      const secondsInYear = 31536000;
      const effectiveDate = this.props.productToTerminate.effectiveDate;
      const currentTime = dates.getUTC();

      // if it has not been a year since the effective date we cannot terminate the product
      if (currentTime - effectiveDate < secondsInYear) {
        return /*#__PURE__*/React.createElement(Modal, {
          small: true,
          open: true,
          onClose: this.props.close,
          title: i18n.t(tokens.titles.productTerminationBlockedTitle),
          primaryButton: {
            label: "Close",
            onClick: this.props.close
          },
          loader: this.props.loader
        }, /*#__PURE__*/React.createElement(Text, {
          align: "left",
          medium: true,
          display: "inline-block"
        }, i18n.t(tokens.labels.marketplace.terminationBlockedYearlyVoluntary)));
      }
    }
    return /*#__PURE__*/React.createElement(Modal, {
      small: true,
      open: true,
      onClose: this.props.close,
      title: i18n.t(tokens.titles.areYouSure),
      loader: this.props.loader,
      primaryButton: {
        label: i18n.t(tokens.labels.marketplace.terminateProduct),
        onClick: async () => {
          const isValid = await this._validateSignageBlock();
          if (isValid) {
            this.props.save(this.state.signage, this.props.isMasterSite ? null : this.state.password);
          }
          return null;
        }
      }
    }, /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, i18n.t(tokens.labels.marketplace.byClickingTerminate), " ", /*#__PURE__*/React.createElement("span", {
      style: {
        fontWeight: 'bold'
      }
    }, productNameToTerminate), " ", i18n.t(tokens.labels.marketplace.thisCannotBeUndone)), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      align: "left",
      medium: true,
      display: "inline-block",
      margin: "20px 0 0 0"
    }, i18n.t(tokens.labels.marketplace.pleaseEnterPasswordToTerminateProduct)), !this.props.isMasterSite && /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.password),
      value: this.state.password,
      inputProps: {
        endAdornment: /*#__PURE__*/React.createElement(InputAdornment, null, this.state.visibility ? /*#__PURE__*/React.createElement(VisibilityIcon, {
          style: {
            cursor: "pointer",
            color: colors.darkGrey,
            marginRight: "8px"
          },
          onClick: this._toggleVisibility
        }) : /*#__PURE__*/React.createElement(VisibilityOffIcon, {
          style: {
            cursor: "pointer",
            color: colors.darkGrey,
            marginRight: "8px"
          },
          onClick: this._toggleVisibility
        }))
      },
      onChange: value => this._handleInputChange('password', value),
      error: Boolean(this.state.passwordError),
      helperText: this.state.passwordError,
      secure: !this.state.visibility,
      fullWidth: true,
      autofocus: true
    }), /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.yourName),
      fullWidth: true,
      value: this.state.signage.name,
      onChange: e => this._handleSignageChange('name', e.target.value),
      error: this.state.signageNameError
    }), /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.signature),
      fullWidth: true,
      value: this.state.signage.signature,
      onChange: e => this._handleSignageChange('signature', e.target.value),
      isSignature: true,
      error: this.state.signageSignatureError
    }), /*#__PURE__*/React.createElement(DateInput, {
      label: i18n.t(tokens.labels.datedOn),
      fullWidth: true,
      value: this.state.signage.datedOn,
      onChange: e => this._handleSignageChange('datedOn', e.target.value),
      error: this.state.signageDatedOnError
    }), /*#__PURE__*/React.createElement(FormGroup, {
      row: true,
      style: {
        marginTop: 20
      }
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: this.state.signage.acceptedTerms,
        onChange: () => this._handleSignageChange('acceptedTerms', !this.state.signage.acceptedTerms),
        value: "acceptedTerms",
        color: "secondary"
      }),
      label: /*#__PURE__*/React.createElement(Text, {
        avMedium: true
      }, i18n.t(tokens.labels.account.acknowledgeInfoAccuracy))
    }))));
  }
}
export default TerminationModal;